import { Navigate, useLocation } from 'react-router-dom';
import { useWebAuth } from '../contexts/WebAuthContext';

/**
 * AuthGuard プロパティ
 */
export interface AuthGuardProps {
  /** 子要素 */
  children: React.ReactNode;
}

/**
 * 認証ガードコンポーネント
 *
 * 未認証ユーザーをログインページにリダイレクトし、
 * 認証チェック中はローディング表示を行う
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useWebAuth();
  const location = useLocation();

  // ローディング中
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-muted border-l-primary-500 rounded-full animate-spin mx-auto" />
          <p className="mt-4 text-muted-foreground">認証を確認中...</p>
        </div>
      </div>
    );
  }

  // 未認証の場合、ログインページへリダイレクト
  if (!isAuthenticated) {
    // 元のURLをredirectパラメータとして渡す
    const redirectUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirectUrl}`} replace />;
  }

  // 認証済み、子要素を表示
  return <>{children}</>;
}
